module.exports = __webpack_public_path__ + "static/media/S4N10-2.42d85fb8.svg";